__turbopack_context__.v({
  "root": "My55ma_root",
});
